import React from 'react';
import { Package } from 'types/package';
import PackageItemModule from './PackageItemModule';
import List from 'components/list/List';

type PackageListModuleProps = {
  packages: Package[];
  handleSearch: () => void;
};

const PackageListModule: React.FC<PackageListModuleProps> = ({ packages, handleSearch }) => {
  return (
    <List>
      {packages.map(pkg => (
        <PackageItemModule handleSearch={handleSearch} key={pkg.id} pkg={pkg} />
      ))}
    </List>
  );
};

export default PackageListModule;
